import { defineComponent as k, onMounted as B, onUnmounted as v, resolveComponent as n, openBlock as o, createElementBlock as u, normalizeClass as V, createBlock as r, createElementVNode as S, createCommentVNode as m, createVNode as h, renderSlot as w, withCtx as i, createTextVNode as a, toDisplayString as s } from "vue";
import $ from "./components/atoms/VButton/VButton.js";
import _ from "./components/atoms/VHTMLText/VHTMLText.js";
import C from "./components/atoms/VIcon/VIcon.js";
import T from "./components/atoms/VLink/VLink.js";
import I from "./components/atoms/VSubtitle/VSubtitle.js";
import { S as L } from "./Spacing-695d3b19.js";
import { V as j } from "./VImage-b57fd9d1.js";
import { _ as N } from "./_plugin-vue_export-helper-dad06003.js";
var M = /* @__PURE__ */ ((t) => (t.xs = "xs", t.s = "s", t.m = "m", t.l = "l", t.xl = "xl", t))(M || {}), y = /* @__PURE__ */ ((t) => (t.large = "large", t.small = "small", t))(y || {}), O = /* @__PURE__ */ ((t) => (t.xs = "xs", t.m = "m", t))(O || {});
const H = k({
  components: { VImage: j, VSubtitle: I, VIcon: C, VHTMLText: _, VLink: T, VButton: $ },
  emits: [
    "state:mounted",
    "state:unmounted",
    "state:primary-button-click",
    "state:secondary-button-click",
    "state:tertiary-button-click"
  ],
  props: {
    title: {
      type: String,
      default: void 0
    },
    icon: String,
    iconType: {
      type: String,
      default: void 0
    },
    iconColor: {
      type: String,
      default: "#d8d8d8"
    },
    iconSize: {
      type: Number,
      default: 135
    },
    iconViewBox: {
      type: String,
      default: void 0
    },
    message: {
      type: String,
      default: void 0
    },
    primaryButton: {
      type: Object,
      default: void 0
    },
    secondaryButton: {
      type: Object,
      default: void 0
    },
    tertiaryButton: {
      type: Object,
      default: void 0
    },
    bottomSpacing: {
      type: String,
      default: "m",
      validator: (t) => ["s", "m", "l", ""].includes(t)
    },
    containerWidth: {
      type: String,
      default: y.small
    },
    animate: {
      type: Boolean,
      default: !1
    },
    router: {
      type: Object,
      required: !0,
      default: void 0
    }
  },
  setup(t, { emit: e }) {
    B(() => e("state:mounted")), v(() => e("state:unmounted"));
  },
  data() {
    return {
      ContainerWidth: y,
      Spacing: L
    };
  }
});
const z = { class: "hobi-subtitle-wrapper" }, E = {
  key: 2,
  class: "hobi-state__cta hobi-state__cta-primary tw-py-2 tw-px-0"
}, W = {
  key: 3,
  class: "hobi-state__cta hobi-state__cta-secondary tw-py-2 tw-px-0"
}, q = {
  key: 4,
  class: "hobi-state__cta hobi-state__cta-tertiary tw-py-2 tw-px-0"
};
function D(t, e, U, A, F, G) {
  const c = n("VImage"), b = n("VIcon"), g = n("VSubtitle"), f = n("VHTMLText"), p = n("VLink"), d = n("VButton");
  return o(), u("div", {
    class: V([
      "hobi-state tw-flex tw-flex-col tw-justify-center tw-items-center tw-text-center",
      t.containerWidth === t.ContainerWidth.small ? "hobi-state--container-small" : "hobi-state--container-large",
      t.animate ? "hobi-state--animated" : ""
    ])
  }, [
    t.icon ? (o(), r(c, {
      key: 0,
      image: t.icon,
      "render-as": "img",
      role: "presentation",
      class: "hobi-state__icon tw-mb-4",
      width: "140px",
      height: "140px"
    }, null, 8, ["image"])) : (o(), r(b, {
      key: 1,
      class: "hobi-state__icon tw-mb-4",
      symbol: t.iconType,
      size: t.iconSize,
      viewBox: t.iconViewBox,
      role: "presentation",
      color: t.iconColor
    }, null, 8, ["symbol", "size", "viewBox", "color"])),
    S("div", z, [
      t.title ? (o(), r(g, {
        key: 0,
        title: t.title,
        size: "l",
        color: "dark"
      }, null, 8, ["title"])) : m("", !0)
    ]),
    h(f, {
      class: "hobi-state__text",
      color: "grey-900",
      size: "m",
      "bottom-spacing": t.Spacing.l,
      "top-spacing": t.Spacing.s,
      htmlText: t.message,
      router: t.router
    }, null, 8, ["bottom-spacing", "top-spacing", "htmlText", "router"]),
    w(t.$slots, "default", {}, void 0, !0),
    t.primaryButton ? (o(), u("div", E, [
      t.primaryButton.url ? (o(), r(p, {
        key: 0,
        href: t.primaryButton.url,
        target: "_parent",
        type: "button",
        order: "primary",
        "bottom-spacing": t.bottomSpacing,
        onClick: e[0] || (e[0] = (l) => t.$emit("state:primary-button-click")),
        router: t.router
      }, {
        default: i(() => [
          a(s(t.primaryButton.title), 1)
        ]),
        _: 1
      }, 8, ["href", "bottom-spacing", "router"])) : (o(), r(d, {
        key: 1,
        bottomSpacing: t.bottomSpacing,
        order: "primary",
        onClick: e[1] || (e[1] = (l) => t.$emit("state:primary-button-click"))
      }, {
        default: i(() => [
          a(s(t.primaryButton.title), 1)
        ]),
        _: 1
      }, 8, ["bottomSpacing"]))
    ])) : m("", !0),
    t.secondaryButton ? (o(), u("div", W, [
      t.secondaryButton.url ? (o(), r(p, {
        key: 0,
        href: t.secondaryButton.url,
        target: "_parent",
        type: "button",
        order: t.secondaryButton.order,
        onClick: e[2] || (e[2] = (l) => t.$emit("state:secondary-button-click")),
        router: t.router
      }, {
        default: i(() => [
          a(s(t.secondaryButton.title), 1)
        ]),
        _: 1
      }, 8, ["href", "order", "router"])) : (o(), r(d, {
        key: 1,
        bottomSpacing: t.bottomSpacing,
        order: t.secondaryButton.order || "tertiary",
        onClick: e[3] || (e[3] = (l) => t.$emit("state:secondary-button-click"))
      }, {
        default: i(() => [
          a(s(t.secondaryButton.title), 1)
        ]),
        _: 1
      }, 8, ["bottomSpacing", "order"]))
    ])) : m("", !0),
    t.tertiaryButton ? (o(), u("div", q, [
      t.tertiaryButton.url ? (o(), r(p, {
        key: 0,
        href: t.tertiaryButton.url,
        target: "_parent",
        type: "button",
        order: t.tertiaryButton.order || "tertiary",
        onClick: e[4] || (e[4] = (l) => t.$emit("state:tertiary-button-click")),
        router: t.router
      }, {
        default: i(() => [
          a(s(t.tertiaryButton.title), 1)
        ]),
        _: 1
      }, 8, ["href", "order", "router"])) : (o(), r(d, {
        key: 1,
        "bottom-spacing": t.bottomSpacing,
        order: t.tertiaryButton.order || "tertiary",
        onClick: e[5] || (e[5] = (l) => t.$emit("state:tertiary-button-click"))
      }, {
        default: i(() => [
          a(s(t.tertiaryButton.title), 1)
        ]),
        _: 1
      }, 8, ["bottom-spacing", "order"]))
    ])) : m("", !0)
  ], 2);
}
const tt = /* @__PURE__ */ N(H, [["render", D], ["__scopeId", "data-v-4cd59836"]]);
export {
  y as C,
  O as L,
  M as S,
  tt as V
};
